import React from "react";
import bannerLogo from '../assets/doclivo.png'
import './CtaBanner.css';

const CtaBanner = () => {
    return (
        <section id="ctaBanner" className=" home-banner">
            <div className="home-banner-content">
                {/* left side */}
                <div className="home-banner-left">
                    <h5>About Us</h5>
                    <h2>What is Doclivo?</h2>
                    <div className="home-banner-logo">
                        <img src={bannerLogo} alt="banner-logo" className="doc-logo-image"></img>
                    </div>
                </div>
                
                {/* right side */}
                <div className="home-banner-right">
                    <p>
                        The premier practice automation platform, enhancing patient experience, provider well-being, and overall practice efficiency.
                        Doclivo is a comprehensive platform designed to meet the needs of healthcare providers ranging from independent doctors to multi-speciality hospitals. It offers an intuitive technology stack that streamlines operations by eliminating the need for managing multiple applications or dealing with interfaces of varying capabilities across different platforms.
                    </p>

                   { /* <button className="home-banner-cta-buton">Explore our story</button> */}

                </div>
            </div>
        </section>
    );
};

export default CtaBanner;